<template>
    <div :class="{'mobile-menu-subgroup-item': true, 'selected': selected}">
        <img v-if="icon" :src="icon" width="16" height="16" /> 
        <span v-else class="no-image"></span>
        <slot>
            <a :href="url"> {{name}}</a>
        </slot>
    </div>
</template>

<script>

export default {
    props: ["name", "icon", "url", ],
    components: {
    },
    mounted() {
        this.refresh();
        window.addEventListener('mobile-menu-recalc-item', this.refresh);
    },
    unmounted() {
        window.removeEventListener('mobile-menu-recalc-item', this.refresh);
    },
    data() {
        return {
            selected: false,
        };
    },
    methods: {
        isCurrent() {            
            const url = document.location.pathname;
            if (url === this.url) {
                return true;
            }
            const index = url.indexOf(this.url);
            if (index > 0) {
                const diff = url.replace(this.url, "");
                if (diff[0] == '/') {
                    if (diff.length == 3) {
                        return true;
                    }
                    if (diff.length == 5 && diff[3] == "-") {
                        return true;
                    }
                }
            }
            return false;
        },
        refresh() {
            this.selected = this.isCurrent();
        },
    }
}
</script>

<style lang="scss" scoped>
    .mobile-menu-subgroup-item {
        display: flex;
        align-items: center;
        padding-left: 18px;
        padding-right: 16px;
        .no-image {
            display: inline-block;
            width: 16px;
            margin-right: 6px;
        }
        img {
            width: 16px;
            position: relative;
            margin-right: 6px;
        }
                
        a { 
            color: #808080;           
            text-decoration: none;
            width: 100%;
        }
    }
</style>

<i18n>
{
    en: {
    },
    ru: {
    }
}
</i18n>
